function Category(categoryData, parent) {
  this.children = () => {
    return categoryData.children
  }
  this.references = () => {
    return categoryData.references
  }
  this.parent = () => {
    return parent
  }
}

module.exports = Category
